import Pidgin from '@lessonnine/pidgin.js';
import { LOCALE } from 'src/dataLayer/env';

const importAll = (req) =>
  req.keys().reduce((acc, file) => {
    const locale = file.replace('./', '').replace('.json', '');
    return {
      ...acc,
      [locale]: req(file)
    };
  }, {});

const locales = importAll(
  require.context('src/viewLayer/assets/locales', false, /\.json$/)
);

const pidgin = new Pidgin({ locales });

const translations = () => {
  if (pidgin.locale !== LOCALE) {
    pidgin.configure({ locale: LOCALE });
  }
  return pidgin;
};

export const t = (key) =>
  translations().t(key);

export const namespaceT = (...args) =>
  translations().namespace(...args);
